import { TabAreeModel } from './tabAree.model';

export class InsertAreeINModel {
    tabAree: TabAreeModel
}